module.exports = __webpack_public_path__ + "img/1557614066318516225.0b3dd5c5.png";